<template>
  <article class="bq-article">
    <h3>{{ title }}</h3>

    <p class="bq-article-tags" v-if="tags">
      <span class="bq-article-tag" v-for="tag in tags" :key="tag">
        {{ tag }}
      </span>
    </p>

    <template v-for="(item, index) in content">
      <img v-if="item.img" :src="item.img" :alt="item.alt" :key="index" />

      <h4 :key="index" v-else-if="item.isTitle">
        {{ item.text }}
      </h4>

      <div
        class="bq-article-links"
        :class="{ mobile: isMobile }"
        :key="index"
        v-else-if="item.isLink"
      >
        <template v-for="(cell, cidx) in item.url">
          <a :href="cell.link" :title="cell.desc" :key="cidx">
            <img :src="cell.icon" :alt="cell.desc" />
            <p>{{ cell.title }}</p>
          </a>
        </template>
      </div>

      <p :class="{ isEmphasize: item.isEmphasize }" :key="index" v-else>
        {{ item.text }}
      </p>
    </template>
  </article>
</template>

<script>
import { isWirelessDevice } from '../../utils/utils.js';

export default {
  name: 'BQArticle',

  props: {
    title: String,
    tags: Array,
    content: Array,
  },

  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },
};
</script>

<style lang="less">
@import './index.less';
</style>
